import { Add, Cancel, Create } from '@mui/icons-material';
import { Alert, Badge, Button, CircularProgress, Grid, Typography } from '@mui/material';

import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { useTilesQuery } from 'api/hooks/tiles';
import { TileType } from 'app/containers';
import { DashboardCard } from 'app/containers/Dashboard/HomePage/components/DashboardCard';
import { selectLayout, selectTileDrawer } from 'app/containers/Dashboard/HomePage/selectors';
import {
  LayoutActions,
  TileDrawerActions
} from 'app/containers/Dashboard/HomePage/tileDrawerSlice';
import { DrawerMode } from 'app/containers/Dashboard/HomePage/types';
import { translations } from 'locales/i18n';

export const PredefinedContent = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const layout = useSelector(selectLayout);
  const selectedTiles = layout.tilesPositions.map(tp => tp.tile);

  const { selectedTilesToAdd } = useSelector(selectTileDrawer);

  const { data: tiles, isLoading } = useTilesQuery({ params: { tileType: TileType.DEFAULT } });

  const addTilesToAddToSelected = tilesArray => {
    tilesArray.forEach(tile => {
      selectedTiles.push(tile);
    });
  };

  const filteredTiles = tiles.filter(
    tile => !selectedTiles.find(selectedTile => selectedTile.id === tile.id)
  );

  const sortedTiles = filteredTiles.sort(tile => {
    const isSelected = selectedTiles.find(selectedTile => selectedTile.id === tile.id);
    if (isSelected) {
      return 1;
    } else {
      return -1;
    }
  });

  const renderDefaultTilesContent = () => {
    if (isLoading) {
      return <CircularProgress />;
    }

    if (sortedTiles.length) {
      return sortedTiles.map(tile => (
        <DashboardCard
          id={tile.id.toString()}
          key={tile.id}
          tile={tile}
          fullWidth
          selectable
          selectedTiles={selectedTiles}
        />
      ));
    } else {
      return t(translations.pages.home.cardDrawer.noDefaultTiles());
    }
  };

  return (
    <Grid
      container
      justifyContent={'space-between'}
      padding={2}
      flexDirection={'column'}
      minHeight={'100vh'}
    >
      <Typography variant="h5" fontWeight={'bold'}>
        {t(translations.pages.home.cardDrawer.predefinedDrawerTitle())}
      </Typography>
      <Alert severity="info">{t(translations.pages.home.cardDrawer.info())}</Alert>
      <Button
        variant="outlined"
        startIcon={<Create />}
        onClick={() => {
          dispatch(TileDrawerActions.setTile(undefined));
          dispatch(TileDrawerActions.setCurrentMode(DrawerMode.CREATE));
        }}
      >
        {t(translations.pages.home.cardDrawer.createOwnTile())}
      </Button>
      <Grid
        container
        item
        gap={4}
        minHeight={'75vh'}
        maxHeight={'75vh'}
        overflow={'auto'}
        alignItems={'center'}
        justifyContent={'center'}
        alignContent={'start'}
        paddingY={2}
        paddingX={1}
      >
        {renderDefaultTilesContent()}
      </Grid>
      <Grid container justifyContent={'flex-end'} gap={2}>
        <Button
          variant="contained"
          style={{ color: 'white', backgroundColor: 'red' }}
          startIcon={<Cancel />}
          onClick={() => dispatch(TileDrawerActions.close())}
        >
          {t(translations.common.cancel())}
        </Button>
        <Badge
          badgeContent={selectedTilesToAdd.filter(t => t.type === TileType.DEFAULT).length}
          color="secondary"
        >
          <Button
            variant="contained"
            style={{ color: 'white' }}
            startIcon={<Add />}
            onClick={() => {
              addTilesToAddToSelected(selectedTilesToAdd);
              dispatch(
                LayoutActions.setLayout(
                  selectedTiles.map((tile, index) => {
                    //Index +1 Because if id = 0, you cant move the tile
                    return { id: index + 1, position: index, tile: tile };
                  })
                )
              );
              dispatch(TileDrawerActions.close());
            }}
          >
            {t(translations.common.add())}
          </Button>
        </Badge>
      </Grid>
    </Grid>
  );
};
